import axios from 'axios';
import apiConfig from '../../api.config';

export default async function invoiceTemplateCheckFileExists(hotelId, chainId, type) {
  const {
    host,
    URIs: { invoiceTemplateCheckFileExists },
  } = apiConfig;

  const uri = `${host}${invoiceTemplateCheckFileExists}`
    .replace(':chainId', chainId)
    .replace(':hotelId', hotelId)
    .replace(':type', type);

  return await axios.get(uri).then(res => res.data);
}
